import { render, staticRenderFns } from "./fahuoaddress.vue?vue&type=template&id=68665ee3&scoped=true&"
import script from "./fahuoaddress.vue?vue&type=script&lang=js&"
export * from "./fahuoaddress.vue?vue&type=script&lang=js&"
import style0 from "./fahuoaddress.vue?vue&type=style&index=0&id=68665ee3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68665ee3",
  null
  
)

export default component.exports